import { render, staticRenderFns } from "./lookArticle.vue?vue&type=template&id=7d4c373d&"
import script from "./lookArticle.vue?vue&type=script&lang=js&"
export * from "./lookArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports